import { create } from "zustand";
import { deleteBulkCall, getBulkCalls, getBulkDetails } from "./bulkApi";

export const useBulkStore = create((set) => ({
  callsPaginated: { data: [], totalCount: 0 },
  selectedBulkCall: null,
  bulkDetails: null,
  error: null,
  loading: false,

  addBulkCall: (call) => {
    set((state) => ({
      callsPaginated: {
        ...state.callsPaginated,
        data: [call, ...state.callsPaginated.data],
        totalCount: state.callsPaginated.totalCount + 1,
      },
      selectedBulkCall: call,
    }));
  },

  deleteBulkCall: async (id) => {
    set({ loading: true, error: null });
    try {
      await deleteBulkCall(id);
      set((state) => ({
        callsPaginated: {
          ...state.callsPaginated,
          data: state.callsPaginated.data.filter((call) => call.id !== id),
          totalCount: state.callsPaginated.totalCount - 1,
        },
        selectedBulkCall: null,
      }));
    } catch (error) {
      set({ error, loading: false });
    }
  },

  getBulkDetails: async (id) => {
    set({ bulkDetails: null, loading: true, error: null });
    try {
      const data = await getBulkDetails(id);
      set({ bulkDetails: data, loading: false });
    } catch (error) {
      set({ error, loading: false });
    }
  },

  loadPage: async (page, pageSize) => {
    set({ loading: true, error: null });
    try {
      const data = await getBulkCalls(page, pageSize);
      set({ callsPaginated: data, loading: false });
    } catch (error) {
      set({ error, loading: false });
    }
  },

  setSelectedBulkCall: (call) => set({ selectedBulkCall: call }),
}));
